/**
 * Copyright © 2026 Adnuntius AS.
 */
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';

import {APP_SHARED} from '../app-shared';
import {AuditHistoryComponent} from '../../report/widget/audit-history.component';

export const CHART_IMPORTS = [
  ...APP_SHARED,
  FormsModule,
  TranslateModule,
  PopoverModule,
  BsDatepickerModule,
  TimepickerModule,
  AuditHistoryComponent
];
